'use client';

import { LayoutContainer, PromoBanner, TextPassage } from '@petsmart-ui/sparky';
import { usePathname } from 'next/navigation';

import { trackBannerClick } from './analytics';
import type { BannerProps } from './types';
import { getBannerDisplay } from './utils';

import './banner.scss';

export type { BannerProps } from './types';

export function Banner(props: BannerProps) {
    const { size, inverted, align, image, cta, onClick } = props;
    const pathname = usePathname();
    const display = getBannerDisplay(props);

    return (
        <LayoutContainer className="banner-container">
            <PromoBanner
                data-testid="sparky-banner-test-id"
                title={display.title}
                imageItems={image.sources}
                imgSrc={image.src}
                imgAlt={image.alt}
                cta={display.showCta}
                onClick={() => {
                    trackBannerClick(props, pathname);
                    onClick?.();
                }}
                headingTagName={display.headingTagName}
                href={cta?.href}
                target={cta?.target}
                linkLabel={cta?.label}
                buttonVariant={cta?.variant}
                size={size}
                inverted={inverted}
                centerText={align === 'center'}
                className="promo-banner"
            >
                {display.description && <TextPassage size={display.descriptionSize}>{display.description}</TextPassage>}
            </PromoBanner>
        </LayoutContainer>
    );
}
